module.exports = __webpack_public_path__ + "static/media/EditorsPick3.fa06b94c.png";